import styled from 'styled-components'

export const BasicCard = styled.div`
  background: ${p => p.theme.palette.white};
  padding: 28px;
  border-radius: 2px;
  background-clip: padding-box;
  box-shadow: 0 1.6px 3.6px 0 rgba(0, 0, 0, 0.232), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.208);
`
